import React from 'react'
import { icons } from 'app/constants'
import './index.css'

const Index = ({ actions }) => {
    return (
        <div className="select-file-options-wrapper">
            <div className="file-select-options-list">
                <div className="files-button-filter" style={{ display: 'flex', gap: '8px' }}>
                    {actions
                        .filter(a => !a.isDisabled)
                        .map(action => {
                            const ICON = icons[action.icon]
                            return (
                                <div
                                    className="user-action-button-wrapper"
                                    key={action.icon}
                                    onClick={action.onClick}
                                >
                                    {ICON && <ICON slot="icon" />}
                                </div>
                            )
                        })}
                </div>
            </div>
        </div>
    )
}

export default React.memo(Index)
